import React, { useState, useEffect, useRef } from 'react'
import Productslider from '../Components/Productslider'
import CategorySlider from '../Components/CategorySlider'
import logo from '../Assets/logo.png'
import { useGlobal } from '../App';
import { FaInstagram, FaChevronDown } from "react-icons/fa6";
import { Link } from "react-router-dom";

export default function Mainpage() {

  const { products, banners } = useGlobal();
  const mainbanner = banners.find(b => b.name === "Main");
  const [categories, setcategories] = useState([]);
  const productsSectionRef = useRef(null);
  const marqueeItems = Array.from({ length: 16 }, (_, i) => i);

  const marqueeText = (mainbanner?.marqueeText || "BUY 4 GET 1").trim() || "BUY 4 GET 1";
  const desktopSpeed = Number(mainbanner?.marqueeSpeedDesktop);
  const mobileSpeed = Number(mainbanner?.marqueeSpeedMobile);
  const resolvedDesktopSpeed = Number.isFinite(desktopSpeed) && desktopSpeed > 0 ? desktopSpeed : 11;
  const resolvedMobileSpeed = Number.isFinite(mobileSpeed) && mobileSpeed > 0 ? mobileSpeed : 40;

  useEffect(() => {
    if (products.length > 0) {
      setcategories([...new Set(products.map(p => p.category))]);
    }
  }, [products]);

  // ===== SORT PRODUCTS BY ORDER =====
  const getSortedProducts = (productsToSort) => {
    return [...productsToSort].sort((a, b) => {
      const orderA = a.order || 0;
      const orderB = b.order || 0;
      
      // المنتجات ذات ترتيب (order > 0) تظهر أولاً
      if ((orderA > 0) !== (orderB > 0)) {
        return (orderB > 0) - (orderA > 0);
      }
      
      // إذا كلاهما لهما ترتيب أو كلاهما بدون، رتب تصاعدياً
      return orderA - orderB;
    });
  };

  const getHomepageCategoryProducts = (categoryName) => {
    const sorted = getSortedProducts(products.filter((product) => product.category === categoryName));
    const normalizedCategory = (categoryName || '').trim().toLowerCase();

    if (normalizedCategory === 'stickers' || normalizedCategory === 'frames') {
      return sorted.slice(0, 12);
    }

    return sorted;
  };

  const handleShopNowClick = () => {
    const scrollDistance = Math.max(window.innerHeight * 0.6, 380);
    window.scrollBy({ top: scrollDistance, behavior: 'smooth' });
  };

  return (
    <div className="page-content d-flex flex-column">

      {/* Loading Animation */}
      <div className={`startinganimation ${products.length > 0 ? '' : 'active'}`}>
        <div className={`imgcontainer ${products.length > 0 ? '' : 'active'}`}>
          <img src={logo} alt="Gedar Logo" />
        </div>
      </div>

      {/* Hero Section */}
      <section
        className='mainsection'
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0.25)), url(${mainbanner?.img})`,
          backgroundSize: 'cover'
        }}
      >
        <div className='d-flex justify-content-end flex-column h-100 mainsectioncontent'>
          <button className='shop-now-btn' onClick={handleShopNowClick}>
            Shop now <FaChevronDown className='shop-now-arrow' aria-hidden='true' />
          </button>
        </div>
      </section>

      <section className='promo-marquee' aria-label='Promotional offer'>
        <div
          className='promo-marquee-track'
          style={{
            "--marquee-speed-desktop": `${resolvedDesktopSpeed}s`,
            "--marquee-speed-mobile": `${resolvedMobileSpeed}s`,
          }}
        >
          <div className='promo-marquee-group'>
            {marqueeItems.map((item) => (
              <span key={`marquee-a-${item}`}>{marqueeText}</span>
            ))}
          </div>
          <div className='promo-marquee-group' aria-hidden='true'>
            {marqueeItems.map((item) => (
              <span key={`marquee-b-${item}`}>{marqueeText}</span>
            ))}
          </div>
        </div>
      </section>

      {/* Product Sliders */}
      <section className='mt-5' ref={productsSectionRef}>
        {categories.map((cat, index) => (
          <Productslider
            key={index}
            products={getHomepageCategoryProducts(cat)}
            category={cat}
          />
        ))}
      </section>

      {/* Categories */}
      <section className='d-flex align-items-center justify-content-center flex-column'>
        <p className='fs-1 text-black categoriesheadermobile'>Categories</p>
        <div className="w-100 d-block d-md-none">
          <CategorySlider banners={[
            { img: banners[2]?.img, title: banners[2]?.title, link: "/category/stickers" },
            { img: banners[7]?.img, title: banners[7]?.title, link: "/category/frames" },
            { img: banners[4]?.img, title: "Customize Your Own", link: "/custom" },
          ]} />
        </div>
        <div className="maxw d-none d-md-block">
          <div className="row">
            <div className="col-4">
              <Link to="/category/stickers" className="catimgcontainer navlink">
                <img src={banners[2]?.img} alt="" />
                <p>{banners[2]?.title}</p>
              </Link>
            </div>
            <div className="col-4">
              <Link to="/category/frames" className="catimgcontainer navlink">
                <img src={banners[7]?.img} alt="" />
                <p>{banners[7]?.title}</p>
              </Link>
            </div>
            <div className="col-4">
              <Link to="/custom" className="catimgcontainer navlink">
                <img src={banners[4]?.img} alt="" />
                <p>Customize Your Own</p>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Instagram Section */}
      <section className='followourinsta d-flex align-items-center justify-content-center'>
        <div className='maxw'>
          <h1>Follow our Instagram account</h1>

          <div className="row">
            {[1, 0, 6, 3].map((i) => (
              <div key={i} className="col-6 col-xl-3 px-2 py-2" >
                <a href={banners[i]?.link}>
                  <div className="instaimgcontainer rounded" style={{overflow:'hidden'}}>
                    <img src={banners[i]?.img} alt="" />
                    <p><FaInstagram /></p>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}
